import {plural} from 'core/helpers';
import {PLURAL_REVIEW_WORDS} from '../constants';
import {IPluralReviewsText} from '../types';

export const pluralReviewsText = ({count, words = PLURAL_REVIEW_WORDS}: IPluralReviewsText) =>
    count ? `${count} ${plural(count, words)}` : '';
